export const ROOT = process.env.VUE_APP_ROOT;
export const VUE_APP_URL = process.env.VUE_APP_URL;
export const APP_TITLE = process.env.VUE_APP_TITLE;
export const API_URL = process.env.VUE_APP_API_URL;
export const RES_URL = process.env.VUE_APP_RES_URL;
export const WIKI_URL = process.env.VUE_APP_WIKI_URL;
export const DCX_URL = process.env.VUE_APP_DCX_URL;
export const ROOT_URL = process.env.VUE_APP_ROOT_URL;
export const DCX_GOOGLE_KEY = process.env.VUE_APP_GOOGLE_KEY;

/** Liste des instances d'arborescence connues
 * @todo Est-ce le bon endroite ? A mettre ailleurs ?
 */
/** Nom de l'instance principale de FilterTree utilisée pour l'arborescence de FullSibar.vue */
export const MAIN_FILTER_TREE: string = "MainFilterTree";
/** Nom de l'instance principale de FilterTree utilisée pour l'arborescence de Selector[???].vue ? */
export const SELECTOR_FILTER_TREE: string = "SelectorFilterTree";

/** Délai d'expiration d'une session en milliseconde. 28800000 millisecondes = 8 heures*/
export const DCX_SESSION_EXPIRATION_DELAY = 28800000;
/** Délai de rafraichissement d'une synchro V3 -> V2. 1200000 millisecondes = 20 minutes */
export const DCX_SYNC_SESSION_EXPIRATION_DELAY = 1200000;
// export const DCX_SYNC_SESSION_EXPIRATION_DELAY = 100;


/** Routes sans session */
export const SESSIONLESS_ROUTES = [
    "Registration",
    "Connexion",
    "Signout",
    "SignInOidc",
    "Signature"
];